/* eslint-disable import/no-mutable-exports */
import platform, { codeEnums } from '@/shared/utils/platform';

/** url同步为当前location.origin，保持跳转前后域名一致，微信小程序跳转到 m2.hellobike.com */
export const urlSyncLocationOrigin = (url: string): string => (
  platform.isWechatMini ? String(url).replace('https://m.hellobike.com', window.location.origin) : url
);

export const baseURL = String(process.env.VUE_APP_REST);

export const gatewayUrl = String(process.env.VUE_APP_GATEWAY);

export const depositGWUrl = String(process.env.VUE_APP_DEPOSIT_GWURL);

export const newGatewayUrl = String(process.env.VUE_APP_NEW_GATEWAY);

export const ubtUrl = process.env.VUE_APP_UBT;

export const vueEnv = String(process.env.VUE_APP_ENV || 'pro');
export const nodeEnv = String(process.env.NODE_ENV || 'production');

export const env = ['fat', 'pro', 'pre', 'uat'].indexOf(vueEnv) >= 0 ? vueEnv : 'fat';

// 校园助力金
export const campusUrl = String(process.env.VUE_APP_CAMPUS);

export const authUrl = String(process.env.VUE_APP_AUTH_API);

export const isPro = vueEnv === 'pro';

// 臻有钱虚拟产品ID
export const ZMoneyVirtualId = '888';

// 是否 h5环境：包含 微信小程序
export const isH5App = !platform.isHelloApp && !platform.isAlipayMini;

// 存款项目产品详情
export const depositUrl = String(process.env.VUE_APP_DEPOSIT_URL);

// 借贷
export const lendingUrl = String(process.env.VUE_APP_FINANCE_URL);

// 信贷新版项目地址
export const loanUrl = urlSyncLocationOrigin(String(process.env.VUE_APP_LOAN_URL));

/** 新项目 臻还卡权益列表地址 */
export const membersRightsUrl = urlSyncLocationOrigin(
  String(process.env.VUE_APP_MEMBERS_RIGHTS_URL),
);

/** 新项目 臻系列卡前缀 */
export const MembersRightsPrefix = urlSyncLocationOrigin(
  String(process.env.VUE_APP_MEMBERS_RIGHTS_PUBLIC_URL),
);

// 银河产品id
export const YinHeCommodityId = 6000;

// pdf协议管理项目地址
export const contractsUrl = urlSyncLocationOrigin(String(process.env.VUE_APP_CONTRACTS_URL));

// 臻有钱持久化缓存key值前缀
export const financeStorageKeyPrefix = `Hellobike_AppFinanceH5Web_${vueEnv}`;

export const sysTag = process.env.VUE_APP_SYS_TAG || '';

const appEnv = (process.env.VUE_APP_ENV || 'dev').toLowerCase();
export const isFatEnv = appEnv.includes('fat');

export const isMockEnv = appEnv.includes('mock');

export const isDevEnv = nodeEnv === 'development';

/** 信贷客服专线电话 */
export const customerServicePhone = '95013555';

// 保险
export const insuranceUrl = urlSyncLocationOrigin(String(process.env.VUE_APP_INSURANCE_URL));

export const androidSpecialDownloadUrl = String(process.env.VUE_APP_ANDROID_SPECIAL_DOWNLOAD_URL);

export const androidCommonDownloadUrl = String(process.env.VUE_APP_ANDROID_COMMON_DOWNLOAD_URL);

// 判断当前origin是否为IP形式
export const isIPOrigin = /^\d+\.\d+\.\d+\.\d+(:\d+)?$/.test(window.location.hostname);

export const financeH5WebUrl = isIPOrigin
  ? window.location.origin + window.location.pathname
  : String(process.env.VUE_APP_FINANCE_H5_WEB_URL);

export const iosDownloadUrl = String(process.env.VUE_APP_IOS_APP_DOWNLOAD_URL);

/** 臻享花 app 客服链接 sourcePage 固定值 */
const CUSTOM_SERVICE_SOURCE_PAGE_ZXH_APP = 'FINANCIAL_ZXH_APP';

/** 哈罗出行 客服地址；臻享花 app 使用借贷条线链接并固定 sourcePage=FINANCIAL_ZXH_APP */
/* 对接文档：https://www.yuque.com/helibike-kf/support/helibike-kf/cm9oh2 */
export const customServiceUrl = (() => {
  const isZxhApp = platform.isSkzhenxhApp;
  const baseUrl = isZxhApp
    ? String(process.env.VUE_APP_CUSTOM_SERVICE_FINANCIAL_URL)
    : String(process.env.VUE_APP_CUSTOM_SERVICE_URL);
  let url = urlSyncLocationOrigin(baseUrl);
  if (isZxhApp) {
    url = url.replace(/([?&])sourcePage=[^&]*/, `$1sourcePage=${CUSTOM_SERVICE_SOURCE_PAGE_ZXH_APP}`);
    if (!url.includes('sourcePage=')) {
      url = `${url}${url.includes('?') ? '&' : '?'}sourcePage=${CUSTOM_SERVICE_SOURCE_PAGE_ZXH_APP}`;
    }
  }
  return url;
})();

/** 哈臻快 IOS 下载地址 */
export const iosRechargeAppDownloadUrl = String(process.env.VUE_APP_RECHARGE_IOS_APP_DOWNLOAD_URL);

/** 哈臻快 Android 下载地址 */
// eslint-disable-next-line max-len
export const androidRechargeAppDownloadUrl = String(process.env.VUE_APP_RECHARGE_ANDROID_APP_DOWNLOAD_URL);

/** 记账app iOS 下载地址 */
// TODO: 待app上架后配置下载地址
export const iosSkzhenxhAppDownloadUrl = String(process.env.VUE_APP_SKZHENXH_IOS_APP_DOWNLOAD_URL || '');

/** 记账app Android 下载地址 */
// TODO: 待app上架后配置下载地址
export const androidSkzhenxhAppDownloadUrl = String(process.env.VUE_APP_SKZHENXH_ANDROID_APP_DOWNLOAD_URL || '');

// 默认选择的职业字段
export const professinDictCode = 1;

/** 登录漏斗埋点支持版本 */
export const LOGIN_FUNNEL_SUPPORT_VERSION = '6.53.0';

/** 哈臻快h5项目地址 */
export const rechargeH5Url = urlSyncLocationOrigin(String(process.env.VUE_APP_RECHARGE_H5_URL));

/** 本项目预渲染h5项目地址 */
export const localPrerenderUrl = urlSyncLocationOrigin(
  String(process.env.VUE_APP_LOCAL_PRERENDER_URL),
);

/**
 * 是否使用通用协议接口（哈臻快、记账app，支持后续扩展新平台：臻有钱独立app、微信小程序...）
 * TODO:待接口上线稳定后，哈啰app也可以考虑接入
 */
export const isUseGeneralAgreesApi = ()
  : boolean => [
  codeEnums.rechargeApp,
  codeEnums.wechatMini,
  codeEnums.skzhenxhApp,
].includes(platform.code);

/** 鸿蒙哈啰app下载 */
export const harmonyAppDownloadUrl = String(process.env.VUE_APP_HARMONY_APP_DOWNLOAD_URL);

// 贷超页面新主体项目地址
export const newLoanMarketUrl = String(process.env.VUE_APP_LOAN_MARKET_URL);

/** 臻有钱-微信小程序url scheme */
export const financeWeiXinMpUrlScheme = String(process.env.VUE_APP_FINANCE_WX_MP_URL_SCHEME);

/** 安卓状态栏默认高度 */
export const DEFAULT_STATUSBAR_HEIGHT = 30;

/** 新版支持试算的场景 */
export const CALC_REPAYPLANS_VERSION = '1.0.0';
